import { defineStore } from 'pinia'

export const usePermissionStore = defineStore('permission', () => {
  const configStore = useConfigStore()
  const { owner, currentTeam, currentTeamPid } = storeToRefs(configStore)

  // Check if we're in demo mode
  const isDemo = computed(() => currentTeamPid.value === 'demo')

  const canAccess = (permission: string) => {
    // Always return true in demo mode
    // NOTE: Development mode bypass temporarily disabled for testing CTA permissions
    // Uncomment the line below to re-enable dev mode bypass:
    // if (import.meta.env.VITE_APP_ENV === 'development' || isDemo.value) {
    if (isDemo.value) {
      return true;
    }

    const accountPermissions = owner.value?.permissions || {}
    const rolePermissions = currentTeam.value?.permissions || {}
    return accountPermissions[permission] || rolePermissions[permission]
  }

  return {
    canAccess,
    isDemo
  }
})
